import { include } from 'named-urls';

export interface INamedRoute {
    path: string;
    name: (location: string) => string;
}

const Routes = {
    home: {
        path: "/",
        name: (location: string) => "home"
    },
    reply: {
        path: "/api/auth/reply",
        name: (location: string) => "Auth reply"
    },
    logout: {
        path: "/auth/logout",
        name: (location: string) => "Auth logout"
    },
    login: {
        path: "/auth/login",
        name: (location: string) => "Auth login"
    },
    offer: {
        path: "/Offer/:name",
        name: (location: string) => {
            var offer = location.split('/')[2];
            return "Offer : " + offer
        }
    },
    order: {
        path: "/order/:name/:ref?/:step?",
        name: (location: string) => {
            var offer = location.split('/')[2];
            return "Order : " + offer
        }
    },
    methodo: {
        path: "/methodo",
        name: (location: string) => "Methodo"
    },
    workspace: {
        path: "/workspace",
        name: (location: string) => "Workspace"
    },
    cookies: {
        path: "/cookies",
        name: (location: string) => "Cookies"
    }
}

export const routeByPath = (path?: string): INamedRoute | undefined => {
    let result: INamedRoute | undefined
    Object.values(Routes).forEach(r => {
        if (r.path === path) {
            result = r;
        }
    })
    return result;
}

export default Routes;
